const category = 'chat';

export const SegmentChatEvent = {
    OPENED: { category, event: 'Opened' },
    CLOSED: { category, event: 'Closed' },
    GROUP_CLICKED: { category, event: 'Board clicked' },
    CHAT_CLICKED: { category, event: 'Chat clicked' },
    COMMENT_ADDED: { category, event: 'Comment added' },
    LEAVE_CHAT_CLICKED: { category, event: 'Leave chat clicked' },
    OPEN_CARD_CLICKED: { category, event: 'Open card details clicked' },
};

export enum SegmentChatOption {
    BOARDS = 'Boards',
    CARDS = 'Cards',
    UNREAD_CHATS = 'Unread chats',
    SOURCE = 'Source',
}
